import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ConsolePanel } from '@/ui';
import type { Community } from '@/core/models/community';

const Panel = styled(ConsolePanel)`
  margin-top: 14px;
`;
const H = styled.h3`
  margin: 0 0 12px;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.color.textPrimary};
`;
const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Row = styled.li`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
`;
const EventDate = styled.span`
  font-family: ${({ theme }) => theme.font.mono};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;
const Empty = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

export function EventsTab({ community }: { community: Community }) {
  return (
    <Panel>
      <H>Upcoming Events</H>
      {community.events.length === 0 ? (
        <Empty>No upcoming events.</Empty>
      ) : (
        <List>
          {community.events.map((e) => (
            <Row key={e.slug ?? e.title}>
              {e.slug ? (
                <Link to={`/events/${encodeURIComponent(e.slug)}`}>{e.title}</Link>
              ) : (
                <span>{e.title}</span>
              )}
              <EventDate>{e.startsAt ? new Date(e.startsAt).toLocaleString() : e.date}</EventDate>
            </Row>
          ))}
        </List>
      )}
    </Panel>
  );
}
